import { createFileRoute, notFound, redirect } from "@tanstack/react-router";

import { ComparePage } from "../components/compare/ComparePage";
import { compareHead } from "../lib/compare/head";
import {
  comparePath,
  compareSlugOf,
  loadCompareCopy,
} from "../lib/compare/index";
import { COMPARE_UI } from "../lib/compare/ui";
import { siteLangOf } from "../lib/marketing/registry";
import { documentHeaders } from "../lib/seo";

/** `/<lang>/compare/<slug>`. Same 301 rule as every other localized route. */
export const Route = createFileRoute("/$lang/compare/$slug")({
  loader: async ({ params }) => {
    const lang = siteLangOf(params.lang);
    if (!lang) throw notFound();
    const slug = compareSlugOf(params.slug);
    if (!slug) throw notFound();

    const path = comparePath(slug, lang);
    if (path !== `/${params.lang}/compare/${params.slug}`)
      throw redirect({ href: path, statusCode: 301 });

    return { lang, slug, copy: await loadCompareCopy(lang) };
  },
  headers: documentHeaders,
  head: ({ loaderData }) =>
    loaderData
      ? compareHead(
          loaderData.slug,
          loaderData.lang,
          loaderData.copy[loaderData.slug],
          COMPARE_UI[loaderData.lang],
        )
      : {},
  component: LocalizedCompare,
});

function LocalizedCompare() {
  const { lang, slug, copy } = Route.useLoaderData();
  return (
    <ComparePage
      slug={slug}
      copy={copy[slug]}
      ui={COMPARE_UI[lang]}
      lang={lang}
      allCopy={copy}
    />
  );
}
